export default __webpack_public_path__ + "static/new-val-e0e7c32bb0b30eb190cef0b301c42ccf.png";